import { escape } from "underscore"

const setOptions = type => {
  if (type === "archive") {
    return {
      title: "Archive",
      buttons: { archive: "Archive" }
    }
  } else if (type === "delete") {
    return {
      title: "Delete",
      buttons: { delete: "Delete" }
    }
  } else {
    return {
      title: "Unarchive",
      buttons: { archive: "Unarchive" }
    }
  }
}

const EventsArchive = {
  initialize() {
    $(document).off("click", ".archive-event-js")

    return $(document).on("click", ".archive-event-js", e => {
      const archiveAction = $(e.target).data("archive-action")
      const archiveUrl = $(e.target).data("archive-url")
      const deleteUrl = $(e.target).data("delete-url")
      const eventName = $(e.target).data("event-name") || "this signup"
      const { buttons, title } = setOptions(archiveAction)
      const content = document.createElement("div")

      let message = ""
      if (archiveAction === "archive") {
        message = `
          <p>
            Archive ${escape(eventName)}
            if you want to remove its public Church Center page but
            keep all the signup details, including registrations, assignments,
            and settings.
          </p>
          <p>
            Archived signups are still accessible from the dashboard and can be
            unarchived if you want to use them again in the future.
          </p>
        `
      } else if (archiveAction === "delete") {
        message = `
          <p>
            This will permanently delete ALL registrations, assignments, and
            settings for ${escape(eventName)}.
          </p>
          <p>
            <strong>This cannot be undone.</strong>
          </p>
        `
      } else {
        message = ""
      }

      content.innerHTML = message

      return alertModal(
        {
          content,
          title: title + " " + eventName + "?",
          buttons: {
            cancel: true,
            ...buttons
          },
          icon: "warning",
          className: "archive-delete-alert",
          closeModal: true
        },
        button => {
          if (button === "archive") {
            return $.ajax({
              method: "POST",
              headers: { "X-CSRF-Token": $.rails.csrfToken() },
              url: archiveUrl
            })
          } else if (button === "delete") {
            return $.ajax({
              method: "DELETE",
              headers: { "X-CSRF-Token": $.rails.csrfToken() },
              url: deleteUrl
            })
          }
        }
      )
    })
  }
}

export default EventsArchive
